// Fetch interceptor - adds Authorization headers automatically for API calls
const originalFetch = window.fetch;

window.fetch = function(url, options = {}) {
  if (typeof url === 'string' && url.includes('/api/')) {
    // Add Authorization header from sessionStorage tokens
    const adminToken = sessionStorage.getItem('admin_token');
    const clientToken = sessionStorage.getItem('client_token');
    
    const headers = options.headers instanceof Headers 
      ? Object.fromEntries(options.headers.entries()) 
      : { ...(options.headers || {}) };
    
    if (adminToken && url.includes('/api/admin')) {
      headers['Authorization'] = `Bearer ${adminToken}`;
    }
    if (clientToken && url.includes('/api/client')) {
      headers['Authorization'] = `Bearer ${clientToken}`;
    }
    
    options = { ...options, headers };
  }
  
  return originalFetch.call(this, url, options);
};
